function getHeaderCartResume(){
    let formatter = new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
    });
    $.ajax({
        url: '/ajax/agenda/riepilogo_carrello.php',
        dataType: 'json',
        success: function (items) {
            if (items.data && items.data.length) {
                let cartTotal = 0;
                let html = '';
                $.each(items.data, function (key, item) {
                    cartTotal = cartTotal + (item.coupon_price > 0 ? item.coupon_price : item.price);
                    let price = item.coupon_price > 0
                        ? `<del>` + formatter.format(item.price) + `</del><br><strong>` + formatter.format(item.coupon_price) + `</strong>`
                        : `<strong>` + formatter.format(item.price) + `</strong>`;
                    let itemName = item.article.alias || item.article.description;
                    if(item.article.translations){
                        let languageObject = item.article.translations.find( item => item.language === ambimedTranslations.lang);
                        if(languageObject){
                            itemName = languageObject.alias || languageObject.description;
                        }
                    }
                    html +=
`<div class="activity">
    <div class="name text-ambimed">` +
        itemName +
    `</div>
    <div class="remove-price">
        <div class="remove">
            ` + ( item.article.id != 48 ?
            `<button class="removeFromCart montserrat font-weight-bold" data-cart="`+ item.id + `">
                ` + (ambimedTranslations.remove[0].toUpperCase() + ambimedTranslations.remove.slice(1).toLowerCase()) + `
            </button>` : '' ) +
        `</div>
        <div class="activity-price text-ambimed">
            ` + (!isCompany ? price : '' ) + `
        </div>
    </div>
</div>`;
                });
                if(!isCompany){
                    html +=
 `<div class="total-price text-right pt-2">`
                    if(cartTotal != items.discount_price){
                        html +=
                            `<div>` + (ambimedTranslations.total[0].toUpperCase() + ambimedTranslations.total.slice(1).toLowerCase()) +  `</div>
    <div class="old">` + formatter.format(cartTotal) + `</div>
    <div>` + formatter.format(items.discount_price) + `</div>`;
                    }else{
                        html +=
                            `<div>` + (ambimedTranslations.total[0].toUpperCase() + ambimedTranslations.total.slice(1).toLowerCase()) +  `</div>
    <div>` + formatter.format(cartTotal) + `</div>`;
                    }
                    html +=
`</div>`;
                }
                $('#cart-resume-header').html(html);
            } else {
                $('#cart-resume-header').html(ambimedTranslations.emptyCart.toUpperCase());
            }
        },
    });
}

function updateCartNumber(){
    $.ajax({
        url: '/ajax/agenda/aggiorna_carrello.php',
        dataType: 'json',
        beforeSend: function() {
            if(typeof loader !== 'undefined') loader.fadeIn();
        },
        success: function (total) {
            $('#menu-container .cartItemsNumber').html(total);
            $('#menu-navbar .cartItemsNumber').html(total);
            if(total === 0) {
                if(typeof timeout !== 'undefined') timeout.remove();
                if(typeof form !== 'undefined') form.remove();
                if(typeof totalPrice !== 'undefined') totalPrice.remove();
                if($('#formCheckout').length > 0 ) $('#formCheckout').remove();
            }
        },
        complete: function() {
            if(typeof loader !== 'undefined') loader.fadeOut();
        }
    });
}
$(document).ready(function(){

    // LOADER
    // $(".loader").fadeOut("slow");

    // HEADER

    function setHeaderTransparent() {
        $('#module_main-header').removeClass('hover');
        $("#module_main-header #main-header-logo").attr("src","/img/ambimed-loghi/ambimed-header-logo.webp");
        $("#module_articles-header #main-header-logo").attr("src","/img/ambimed-loghi/ambimed-header-logo.webp");
    }
    function setHeaderWhite() {
        $('#module_main-header').addClass('hover');
        $("#module_main-header #main-header-logo").attr("src","/img/ambimed-loghi/ambimed-header-logo.webp");
        $("#module_articles-header #main-header-logo").attr("src","/img/ambimed-loghi/ambimed-header-logo.webp");
    }
    function adaptHeaderClass() {
        if($(document).scrollTop() <= 20) {
            setHeaderTransparent();
        }
        if($(document).scrollTop() > 20) {
            setHeaderWhite();
        }
    }

    // var url= window.location.href;
    // if(url.split("/").length>3){
    //     console.log('homepage');
    // } else {
    //     console.log('articolo');
    // }

    // Adatta la classe dell'header al caricamento o al refresh della pagina
    adaptHeaderClass();

    // Adatta la classe dell'header allo scorrimento della pagina
    $(document).scroll(function () {
        adaptHeaderClass();
    });

    $('#module_main-header, #module_articles-header').mouseenter(function(){
        $('.submenu').each(function(){
            $(this).addClass('d-none');
        });
        setHeaderWhite();
    });
    $('#module_main-header, #module_articles-header').mouseleave(function(){
        $('.submenu').each(function(){
            $(this).addClass('d-none');
        });
        adaptHeaderClass();
    });


    // INTRO

    $("#intro-scroller").click(function (){
        $('html, body').animate({
            scrollTop: $("#intro-scrollpoint").offset().top - 83
        }, 1000);
    });


    // MENU

    function setActiveLink(el) {
        $('#menu-navbar').find('.active').each(function(){
            $(this).removeClass('active');
        });
        $(el).toggleClass('active');
    }

    $('#btnMenuAzienda').on('click', function(){
        setActiveLink($(this));
        setHeaderWhite();

        $('#menuAzienda').toggleClass('d-none');
        $('#menuB2C').addClass('d-none');
        $('#menuB2B').addClass('d-none');
        $('#menuRed').addClass('d-none');
        $('#divRicerca').addClass('d-none');
    });

    $('#btnMenuB2C').on('click', function(){
        setActiveLink($(this));
        setHeaderWhite();

        $('#menuB2C').toggleClass('d-none');
        $('#menuAzienda').addClass('d-none');
        $('#menuB2B').addClass('d-none');
        $('#menuRed').addClass('d-none');
        $('#divRicerca').addClass('d-none');
    });

    $('#btnMenuB2B').on('click', function(){
        setActiveLink($(this));
        setHeaderWhite();

        $('#menuB2B').toggleClass('d-none');
        $('#menuAzienda').addClass('d-none');
        $('#menuB2C').addClass('d-none');
        $('#menuRed').addClass('d-none');
        $('#divRicerca').addClass('d-none');
    });

    $('#btnMenuRed').on('click', function(){
        setActiveLink($(this));
        setHeaderWhite();

        $('#menuRed').toggleClass('d-none');
        $('#menuAzienda').addClass('d-none');
        $('#menuB2C').addClass('d-none');
        $('#menuB2B').addClass('d-none');
        $('#divRicerca').addClass('d-none');
    });

    $('.btnRicerca').on('click',function(){
        console.log('cliccato su ricerca');
        setActiveLink($(this));
        setHeaderWhite();

        $('#divRicerca').toggleClass('d-none');
        $('#menuAzienda').addClass('d-none');
        $('#menuB2C').addClass('d-none');
        $('#menuB2B').addClass('d-none');
        $('#menuRed').addClass('d-none');
    })

    /* Ambimed News */
    $('#btnAmbimedNewsSubmit').click(function() {

        function validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        }

        function postToWebhook(hookUrl, formData) {
            $.ajax({
                url: hookUrl,
                method: 'POST',
                data: formData
            }).done(function(){
                $('#btnAmbimedNewsSubmit').html('<i class="fas fa-check"></i> Grazie!').attr('disabled', true);
            });
        }

        let name = $('#ambimed-news-form input[name="name"]').val()
        let email = $('#ambimed-news-form input[name="email"]').val()
        let choice = $('#ambimed-news-form input[name="choice"]:checked').val()
        let privacy = $('#ambimed-news-form input[name="privacy"]:checked').val()

        if (name === '' || email === '' || validateEmail(email) === false || choice === '' || choice === undefined ) {
            alert('Assicurati di aver compilato correttamente tutti i campi per favore.');
            return;
        }
        if (privacy === '' || privacy === undefined) {
            alert('E\'necessario prestare il consenso al trattamento dei dati accettando l\'informativa sulla privacy.');
            return;
        }

        let hookUrl1 = '';
        let hookUrl2 = '';
        let formData = {
            'name': name,
            'email': email,
        }
        switch (choice) {
            case 'mdv':
                hookUrl1 = 'https://hook.eu1.make.com/ctcr9ue7dbr7tkj2tgcgz2u5u4x8w4u4';
                postToWebhook(hookUrl1, formData)
                break;
            case 'mdl':
                hookUrl1 = 'https://hook.eu1.make.com/1f5p6ap1uejvfof216zvxsjweyyc5wr8';
                postToWebhook(hookUrl1, formData);
                break;
            case 'both':
                hookUrl1 = 'https://hook.eu1.make.com/ctcr9ue7dbr7tkj2tgcgz2u5u4x8w4u4';
                postToWebhook(hookUrl1, formData);
                hookUrl2 = 'https://hook.eu1.make.com/1f5p6ap1uejvfof216zvxsjweyyc5wr8';
                postToWebhook(hookUrl2, formData);
                break;
        }
    });

    $('#newsletter_check').click(function(){
        if($(this).is(':checked')){
            $('#mc-embedded-subscribe').attr('disabled', false);
        } else {
            $('#mc-embedded-subscribe').attr('disabled', true);
        }
    });

    $('#ambimed-news-form input[name="choice"], #ambimed-news-form input[name="privacy"]').click(function(){
        if($('#ambimed-news-form input[name="choice"]').is(':checked') && $('#ambimed-news-form #privacy').is(':checked')){
            $('#btnAmbimedNewsSubmit').attr('disabled', false);
        } else {
            $('#btnAmbimedNewsSubmit').attr('disabled', true);
        }
    });
    /* FINE Ambimed News */

    [].forEach.call(document.querySelectorAll('img[data-src]'), function(img) {
            img.setAttribute('src', img.getAttribute('data-src'));
            img.onload = function() {
            img.removeAttribute('data-src');
        };
    });

    /* FancyBox */
    $("#article-img").fancybox({
        'animation' : 'elastic'
    });

    /* Layout in primo piano */

    // Create the masonry grid
    var grid = $('.grid').masonry({
        itemSelector: '.grid-item'
    });

    $('a[data-toggle=tab]').each(function () {
        var $this = $(this);

		$this.on('shown.bs.tab', function () {
            grid.masonry({
                itemSelector: '.grid-item'
            });

		}); //end shown
    });
    
    /*
    * COMPUTE CODICE FISCALE
    */
    $("#nome").on('keyup', function(){
        $("#name").val($("#nome").val());
    });

    $("#cognome").on('keyup', function(){
        $("#surname").val($("#cognome").val());
    });


    $('#generaCF').click(function(ev){
            ev.preventDefault();
            let cf = new CodiceFiscale({
                name : $("#name").val(),
                surname : $("#surname").val(),
                gender : $("#gender").val(),
                birthday : $("#birthday").val(),
                birthplace : $("#birthplace").val()
            });

            $("#cf-1").val(cf.toString());
        
    });

$("#copy").click(function(){
    var codice = $('#cf-1').val();
    $('#codice_fiscale').val(codice);
    $('.modal').modal('hide');
});

    /* Login */

    $('#frmLogin').keypress(function(e){
        var dati = $('#frmLogin').serialize();
        if(e.which == 13){
            $.ajax({
                url: '/ajax/paziente/login.php',
                method: 'POST',
                data: dati
            }).done(function(response){
                if(response == "Ok"){
                    window.location = "/my-ambimed";
                } else {
                    $('#respLogin').html(response);
                }
            });
        }
    });

    $('#btnLogin').click(function(){
        var dati = $('#frmLogin').serialize();
        $.ajax({
            url: '/ajax/paziente/login.php',
            method: 'POST',
            data: dati
        }).done(function(response){
            if(response == "Ok"){
                window.location = "/my-ambimed";
            } else {
                $('#respLogin').html(response);
            }
        })
    });

    /* Login MDL */

    $('#frmLoginMDL').keypress(function(e){
        var dati = $('#frmLoginMDL').serialize();
        if(e.which == 13){
            $.ajax({
                url: '/ajax/mdl/login.php',
                method: 'POST',
                data: dati
            }).done(function(response){
                if(response == "Ok"){
                    window.location = "/" + ambimedTranslations.lang;
                } else {
                    $('#respLoginMDL').html(response);
                }
            });
        }
    });

    $('#btnLoginMDL').click(function(){
        var dati = $('#frmLoginMDL').serialize();
        $.ajax({
            url: '/ajax/mdl/login.php',
            method: 'POST',
            data: dati
        }).done(function(response){
            if(response == "Ok"){
                window.location = "/" + ambimedTranslations.lang +"/" + ambimedTranslations.myambimedEmployeeArea;
            } else {
                $('#respLoginMDL').html(response);
            }
        })
    });

    /* Recupero dati */
    $('#btnRecuperoDati').click(function(){
        $('#respRecuperoDati').html("<h4 class='text-center'>"+ambimedTranslations.emailProgress+" <img src='/img/spinner.gif' width='30'/></h4>");
        var dati = $('#frmRecuperoDati').serialize();
        $.ajax({
            url: '/ajax/paziente/recupero_dati.php',
            method: 'POST',
            data: dati
        }).done(function(response){
            $('#respRecuperoDati').html(response);
        })
    });

    $('#email_rec').on('keyup', function() {
        $('#codice_fiscale_rec').text("").val(""); 
        $('#documento_estero_rec').text("").val(""); 
    });

    $('#codice_fiscale_rec').on('keyup', function() {
        $('#email_rec').text("").val(""); 
        $('#documento_estero_rec').text("").val(""); 
    });

    $('#documento_estero_rec').on('keyup', function() {
        $('#email_rec').text("").val(""); 
        $('#codice_fiscale_rec').text("").val(""); 
    });

    /* Richiesta prenotazione */
    $('#btnPrenotazione').click(function(){
        $('html,body').animate({
            scrollTop: $("#respPrenotazione").offset().top},
            'slow');
        $('#respPrenotazione').html("<h4 class='text-center'>"+ambimedTranslations.emailProgress+" <img src='/img/spinner.gif' width='30'/></h4>");
        var dati = $('#frmPrenotazione').serialize();
        $.ajax({
            url: '/ajax/prenotazione_sito.php',
            method: 'POST',
            data: dati
        }).done(function(response){
            $('#respPrenotazione').html(response);
        })
    });
    
    /* Richiesta contatti */
    $('#btnContatti').click(function(){
        $('html,body').animate({
            scrollTop: $("#respPrenotazione").offset().top},
            'slow');
        $('#respPrenotazione').html("<h4 class='text-center'>"+ambimedTranslations.emailProgress+" <img src='/img/spinner.gif' width='30'/></h4>");
        var dati = $('#frmContatti').serialize();
        $.ajax({
            url: '/ajax/invio_email.php',
            method: 'POST',
            data: dati
        }).done(function(response){
            $('#respPrenotazione').html(response);
        })
    });

    /* Richiesta partnership */
    $('#btnRichiestaPartner').click(function(){
        $('html,body').animate({
            scrollTop: $("#response").offset().top},
            'slow');
        $('#response').html("<h4 class='text-center'>"+ambimedTranslations.emailProgress+" <img src='/img/spinner.gif' width='30'/></h4>");
        var dati = $('#frmRichiestaPartner').serialize();
        $.ajax({
            url: '/ajax/invio_richiesta_partner.php',
            method: 'POST',
            data: dati
        }).done(function(response){
            $('#response').html(response);
        })
    });

    /* Richiesta Recall */
    $('#recall_privacy').click(function(){
        if($(this).is(':checked')){
            console.log('acc');
            $('#btnRecall').attr('disabled', false);
        } else {
            console.log('spe');
            $('#btnRecall').attr('disabled', true);
        }
    });

    $('#btnRecall').click(function(){
        $('#respRecall').html("<span class='text-center'>"+ambimedTranslations.emailProgress+" <img src='/img/spinner.gif' width='30'/></span>");
        var dati = $('#frmRecall').serialize();
        $.ajax({
            url: '/ajax/invio_email_recall.php',
            method: 'POST',
            data: dati
        }).done(function(response){
            $('#respRecall').html(response);
        })
    });



    
    /*  Iscrizione al gestionale */
    $('#btnMyAmbimed').on('click',function(e){
        e.stopPropagation();
        $('#myAmbimed').addClass('show');
        $('#myAmbimed').parent().addClass('show');
        $('.myambimed').attr("aria-expanded","true");
        $('html,body').animate({
            scrollTop: $("#myAmbimed").offset().top},
            'slow');
    })

    $('#btnIscrizione').click(function(){
        $('html,body').animate({
            scrollTop: $("#respIscrizione").offset().top},
            'slow');
        $('#respIscrizione').html("<h5 class='text-center'>"+ambimedTranslations.operationProgress+" <img src='/img/spinner.gif' width='30'/></h5>");
        var dati = $('#frmIscrizione').serialize();
        $.ajax({
            url: '/ajax/paziente/aggiungi_paziente.php',
            method: 'POST',
            data: dati
        }).done(function(response){
            if(response == "Ok"){
                $('#respIscrizione').html('');
                $('#respIscrizione').html('<div class="alert alert-success" role="alert">'+ambimedTranslations.successSubscribe+'</div>');
            } else {
                $('#respIscrizione').html('');
                $('#respIscrizione').html('<div class="alert alert-danger" role="alert">'+response+'</div>');
            }
        })
    });

    /* Modifica password */
    $('#btnModifica').click(function(){
        $('#respModifica').html("<h5 class='text-center'>"+ambimedTranslations.operationProgress+" <img src='/img/spinner.gif' width='30'/></h5>");
        var dati = $('#frmModifica').serialize();
        $.ajax({
            url: '/ajax/paziente/modifica_password.php',
            method: 'POST',
            data: dati
        }).done(function(response){
            if(response == "Ok"){
                $('#respModifica').html('');
                $('#respModifica').html('<div class="alert alert-success" role="alert">'+ambimedTranslations.successPassword+'</div>');
            } else {
                $('#respModifica').html('');
                $('#respModifica').html('<div class="alert alert-danger" role="alert">'+response+'</div>');
            }
        })
    });

    /* Varie */
    $('#btnPaese').click(function(){
        var alias = $('#selPaese').val();
        if(isNaN(alias)){
            window.open('/'+ambimedTranslations.lang+'/'+ambimedTranslations.sheet.toLowerCase()+'/'+alias);
        }
    });

    /* SCHEDE PAESE */
    $('.schede_container').each( function(){
        let thisContainer = $(this).find('.d-none');
        let thisParent = $(this).parent();
        thisParent.click(() => thisParent.find(thisContainer).slideToggle());
        thisContainer.hide().removeClass('d-none');
    });


    $('#customers').owlCarousel({
        margin: 50,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: false,
        rewind: true,
        autoplayTimeout: 2000,
        dots: false,
        responsive : {
            480 : { items : 1  }, // from zero to 480 screen width 4 items
            768 : { items : 2  }, // from 480 screen width to 768 6 items
            1024 : { items : 5 }  // from 768 screen width to 1024 8 items
        },
    });


    $('#alerts').owlCarousel({
        margin: 0,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: true,
        rewind: true,
        autoplayTimeout: 3500,
        dots: false,
        responsive : {
            480 : { items : 1  }, // from zero to 480 screen width 4 items
            1200 : { items : 2  }, // from 480 screen width to 768 6 items
            1800 : { items : 4 }  // from 768 screen width to 1024 8 items
        },
    });

    $('#alert .owl-carousel').owlCarousel({
        margin: 50,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: true,
        rewind: true,
        autoplayTimeout: 3500,
        dots: false,
        responsive : {
            480 : { items : 1  }, // from zero to 480 screen width 4 items
            1200 : { items : 2  }, // from 480 screen width to 768 6 items
            1800 : { items : 3 }  // from 768 screen width to 1024 8 items
        },
    });

    $('#mdv-customers').owlCarousel({
        margin: 50,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: false,
        rewind: true,
        autoplayTimeout: 2000,
        dots: false,
        responsive : {
            480 : { items : 1  }, // from zero to 480 screen width 4 items
            768 : { items : 2  }, // from 480 screen width to 768 6 items
            1024 : { items : 5 }  // from 768 screen width to 1024 8 items
        },
    });


    // Slider servizi BU home page
    $('#carousel-mdv').owlCarousel({
        margin: 0,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: true,
        autoplayTimeout: 5000,
        dots: false,
        responsive : {
            480 : {
                items : 1,
                dots: true,
            }, // from zero to 480 screen width 4 items
            768 : {
                items : 2,
                dots: true,
            }, // from 480 screen width to 768 6 items
            1024 : {
                items : 4,
                dots: true,
            }  // from 768 screen width to 1024 8 items
        },
    });
    $('#carousel-btm').owlCarousel({
        margin: 0,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: true,
        autoplayTimeout: 5000,
        dots: false,
        responsive : {
            480 : {
                items : 1,
                dots: true,
            }, // from zero to 480 screen width 4 items
            768 : {
                items : 2,
                dots: true,
            }, // from 480 screen width to 768 6 items
            1024 : {
                items : 4,
                dots: true,
            }  // from 768 screen width to 1024 8 items
        },
    });
    $('#carousel-mdl').owlCarousel({
        margin: 0,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: true,
        autoplayTimeout: 5000,
        dots: false,
        responsive : {
            480 : {
                items : 1,
                dots: true,
            }, // from zero to 480 screen width 4 items
            768 : {
                items : 2,
                dots: true,
            }, // from 480 screen width to 768 6 items
            1024 : {
                items : 3,
                dots: true,
            }  // from 768 screen width to 1024 8 items
        },
    });
    $('#carousel-prv').owlCarousel({
        margin: 0,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: true,
        autoplayTimeout: 5000,
        dots: false,
        responsive : {
            480 : {
                items : 1,
                dots: true,
            }, // from zero to 480 screen width 4 items
            768 : {
                items : 2,
                dots: true,
            }, // from 480 screen width to 768 6 items
            1024 : {
                items : 3,
                dots: true,
            }  // from 768 screen width to 1024 8 items
        },
    });


    // Slider immagini BU
    $('#mdv-images').owlCarousel({
        margin: 0,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: true,
        autoplayTimeout: 2500,
        dots: false,
        responsive : {
            480 : {
                items : 1,
                dots: true,
            }, // from zero to 480 screen width 4 items
            768 : {
                items : 2,
                dots: true,
            }, // from 480 screen width to 768 6 items
            1024 : {
                items : 4,
                dots: true,
            }  // from 768 screen width to 1024 8 items
        },
    });
    $('#btm-images').owlCarousel({
        margin: 0,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: true,
        autoplayTimeout: 2500,
        dots: false,
        responsive : {
            480 : {
                items : 1,
                dots: true,
            }, // from zero to 480 screen width 4 items
            768 : {
                items : 2,
                dots: true,
            }, // from 480 screen width to 768 6 items
            1024 : {
                items : 4,
                dots: true,
            }  // from 768 screen width to 1024 8 items
        },
    });
    $('#mdl-images').owlCarousel({
        margin: 0,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: true,
        autoplayTimeout: 2500,
        dots: false,
        responsive : {
            480 : {
                items : 1,
                dots: true,
            }, // from zero to 480 screen width 4 items
            768 : {
                items : 2,
                dots: true,
            }, // from 480 screen width to 768 6 items
            1024 : {
                items : 4,
                dots: true,
            }  // from 768 screen width to 1024 8 items
        },
    });
    $('#prv-images').owlCarousel({
        margin: 0,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: true,
        autoplayTimeout: 2500,
        dots: false,
        responsive : {
            480 : {
                items : 1,
                dots: true,
            }, // from zero to 480 screen width 4 items
            768 : {
                items : 2,
                dots: true,
            }, // from 480 screen width to 768 6 items
            1024 : {
                items : 4,
                dots: true,
            }  // from 768 screen width to 1024 8 items
        },
    });






    $('.related-carousel').owlCarousel({
        margin: 0,
        responsiveClass: true,
        items : 1, // THIS IS IMPORTANT
        autoplay: true,
        loop: false,
        autoplayTimeout: 2000,
        dots: false,
        responsive : {
            480 : {
                items : 1,
                dots: true,
            }, // from zero to 480 screen width 4 items
            768 : {
                items : 2,
                dots: true,
            }, // from 480 screen width to 768 6 items
            1024 : {
                items : 4,
                dots: true,
            }  // from 768 screen width to 1024 8 items
        },
    });





    $('#carousel-mdv').show();
    $('#carousel-btm').hide();
    $('#carousel-mdl').hide();
    $('#carousel-prv').hide();

    $('#btnServiziMDV').click(function(e) {
        e.preventDefault();
        $('#carousel-mdv').show();
        $('#carousel-btm').hide();
        $('#carousel-mdl').hide();
        $('#carousel-prv').hide();
    });

    $('#btnServiziBTM').click(function(e) {
        e.preventDefault();
        $('#carousel-mdv').hide();
        $('#carousel-btm').show();
        $('#carousel-mdl').hide();
        $('#carousel-prv').hide();
    });

    $('#btnServiziMDL').click(function(e) {
        e.preventDefault();
        $('#carousel-mdv').hide();
        $('#carousel-btm').hide();
        $('#carousel-mdl').show();
        $('#carousel-prv').hide();
    });

    $('#btnServiziPRV').click(function(e) {
        e.preventDefault();
        $('#carousel-mdv').hide();
        $('#carousel-btm').hide();
        $('#carousel-mdl').hide();
        $('#carousel-prv').show();
    });

    $('#tipo_utente').change(function(){
        var val = $('#tipo_utente').val();
        if(val == 1){
            $('#divAzienda').slideDown();
        } else {
            $('#divAzienda').slideUp();
        }
    });

    $('.popup-bio').tooltip();

    /* Registrazione paziente */

    // Città di nascita

    $('#estero .form-group').hide().removeClass('d-none');

    $('#stato_nascita').change(function(){
        var value = $('#stato_nascita').val();
        if(value != 106){
            $('#italia').slideUp();
            $('#estero .form-group').slideDown();
            $('#luogo_nascita').val("");
            $('#luogo_nascita_id').val("");
        }
        if(value == 106){
            $('#italia').slideDown();
            $('#estero .form-group').slideUp();
            $('#citta_estera').val("");
        }
    });

    /* Social share */

    $('#share').sharetastic(
        {
            popup: true,
            services: {
                twitter: false,
                pinterest: false,
                googleplus: false,
                tumblr: false,
                flickr: false,
                email: false,
                print: false
            }
        }
    );

    /* Margine social su pagine ecommerce */
    if(/gestione-consensi-gdpr/.test(window.location.href)) 
    {
        $("input[name='gdpr1']").click(function(){
            if($(this).val() == 0){
                $('#alert_servizi').html("<div class='alert alert-warning mb-0 mt-3'>"+ambimedTranslations.noGDPR+"</div>");
            } else {
                $('#alert_servizi').html("");
            }
        });
    }

    /* Tab attivo per Malattie e vaccinazioni se clicchi da Per i privati */
    if (/#altre/.test(window.location.href)){
        $('#pills-tropicali-tab').removeClass('active');
        $('#pills-tropicali-tab').prop('aria-selected','false');
        $('#pills-tropicali').removeClass('active show');
        $('#pills-altre-tab').addClass('active');
        $('#pills-altre-tab').prop('aria-selected','true');
        $('#pills-altre').addClass('show active');
    }

    $.protip();
    
    $('.protip').protipSet({
        position:'bottom',
        trigger: 'click',
        delayIn: 300,
        delayOut: 100,
        animate: 'fadeIn',
    });

    $('#cart-resume-li').hover(() => $('#cart-resume-header').slideDown('fast'), () => $('#cart-resume-header').slideUp('fast'));
    getHeaderCartResume();
    $('#cart-resume-header').on('click','.removeFromCart', function () {
        let cart = $(this).data('cart')
        $.ajax({
            url: '/ajax/agenda/rimuovi_dal_carrello.php',
            method: 'POST',
            dataType: 'json',
            data: {cart},
            success: function(response) {
                getHeaderCartResume();
                updateCartNumber();
                if(typeof getCartResume === 'function') getCartResume();
                if($('#btnCheckoutNoAgenda').length == 1 && response.data.length == 0){
                    $('#btnCheckoutNoAgenda').removeClass('disabled');
                    $('.finalize-alert').remove();
                }
            }
        });
    });

});
// document.addEventListener('touchstart', onTouchStart, {passive: true});